import { useCallback, useEffect, useState } from "react";
import { getSchedules } from "../api/schedulesApi";

export function useScheduleList({ listScope = "self" } = {}) {
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getSchedules({ scope: listScope });
      setAllRows(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      setError(err?.message || "Failed to load schedules");
      setAllRows([]);
    } finally {
      setLoading(false);
    }
  }, [listScope]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { allRows, loading, error, refresh };
}
